import { Grid } from "@mui/material";
import CONSTANTS from "core/constants";
import { useGetQuestionnaireContentQuery } from "api/useQuestionnaireQueries";
import { UserAnswer } from "core/types";
import { format } from "date-fns";
import { Typography } from "components/typography";
import { QuestionnaireModal } from "./modal.styles";
import { QuestionnaireContent } from "./questionnaireContent";
import { Spacing } from "@mindlercare/ui-web";

export const ViewQuestionnaireModal = ({
  setModalIsOpen,
  clinicalId,
  open,
  patientName,
  requestId,
  patientUserId,
  answers,
}: {
  setModalIsOpen: (arg: boolean) => void;
  clinicalId?: string;
  open: boolean;
  patientName: string;
  requestId?: string;
  patientUserId?: number;
  answers?: UserAnswer[];
}) => {
  const { data: questionnaireContent } =
    useGetQuestionnaireContentQuery(clinicalId);

  const answerTime = answers?.[0]?.createdAt
    ? format(
        new Date(answers[0].createdAt),
        CONSTANTS.DATE_FORMAT.DEFAULT_DATE_FORMAT,
      )
    : "";
  const titleComponent = (
    <Grid container direction="column">
      <Grid item>
        <Typography variant="h3">
          {questionnaireContent?.clinicalId ?? "--"}
          {": "}
          {questionnaireContent?.clinicalName ?? "--"}
        </Typography>
      </Grid>
      <Spacing t={2} />
      <Grid item>
        <Typography variant="h5" color="GRAY_DARK">
          {`${patientName ?? "--"} · ${questionnaireContent?.name ?? "--"} · ${
            answerTime ?? "--"
          }`}
        </Typography>
      </Grid>
    </Grid>
  );

  return (
    <QuestionnaireModal
      onClose={() => setModalIsOpen(false)}
      titleComponent={titleComponent}
      open={open}
      size="large"
      isScrollable={false}
    >
      <QuestionnaireContent
        clinicalId={clinicalId}
        requestId={requestId}
        patientUserId={patientUserId}
        questionnaireType={"clinical"}
      />
    </QuestionnaireModal>
  );
};
